module.exports = __webpack_public_path__ + "img/hacienda-room-5.4d1ba8bb.jpg";